export default function Section({ children, id, className = "" }) {
  return (
    <section id={id} className={`section-padding ${className}`}>
      {children}
    </section>
  );
}